//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
    data: function data() {
        return {
            loading: true
        };
    },
    created: function created() {
        Event.$on('property-settings-offboard-property', this.load);
    },
    beforeDestroy: function beforeDestroy() {
        Event.$off('property-settings-offboard-property');
    },

    methods: {
        load: function load() {
            this.$children[0].$data.showSmallModal = true;
        },
        save: function save() {
            var _this = this;

            var payload = { propertyId: this.$store.state.selectedProperty };
            axios.post('/prototype/properties/offboard', payload).then(function () {
                _this.load();
            });
        },
        close: function close() {
            this.$children[0].$data.showSmallModal = false;
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/property/settings/PropertySettingsOffboardProperty.vue
// module id = QfAW
// module chunks = 0 1